import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  getNavigateToLoginOptions,
  setIntendedDestinationForLogin,
} from '../../utils/authSessionExpired';
import logo from '../../assets/images/nky_connect_logo_only.png';
import {
  BrandSection,
  CenterLinks,
  LaunchAppBar,
  LaunchContainer,
  LaunchLinkButton,
  LaunchToolbar,
  LoginButton,
  LogoButton,
  LogoImage,
  MobileDivider,
  MobileInline,
  RightActions,
} from './LaunchNavBar.styled';

export default function LaunchNavBar() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleLogin = () => {
    setIntendedDestinationForLogin('/');
    navigate('/login', getNavigateToLoginOptions('/'));
  };

  return (
    <LaunchAppBar position="static">
      <LaunchContainer maxWidth="xl">
        <LaunchToolbar disableGutters>
          <BrandSection>
            <LogoButton
              component={RouterLink}
              to="/launch"
              aria-label="NKY Connect launch home"
            >
              <LogoImage src={logo} alt="NKY Connect" />
            </LogoButton>

            <MobileInline>
              <MobileDivider orientation="vertical" flexItem />
              <LaunchLinkButton component={RouterLink} to="/launch" color="inherit">
                Home
              </LaunchLinkButton>
            </MobileInline>
          </BrandSection>

          <CenterLinks>
            <LaunchLinkButton component={RouterLink} to="/launch" color="inherit">
              Home
            </LaunchLinkButton>
          </CenterLinks>

          <RightActions>
            <LoginButton variant="contained" onClick={handleLogin} disabled={Boolean(user)}>
              {user ? 'Logged in' : 'Login'}
            </LoginButton>
          </RightActions>
        </LaunchToolbar>
      </LaunchContainer>
    </LaunchAppBar>
  );
}

